'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var preferVendorTimestamp = exports.preferVendorTimestamp = function preferVendorTimestamp(payload) {
  var message = payload.message,
      timestamp = payload.timestamp;


  var hasMessageTimestamp = message && typeof message.timestamp === 'number';

  if (timestamp && hasMessageTimestamp) {
    message.timestamp = timestamp;
  }
  return _extends({}, payload, { message: message });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/conversations-pub-sub/operators/preferVendorTimestamp.js
// module id = 410
// module chunks = 2 3